module.exports = __webpack_public_path__ + "static/media/agreement-customer.da3f9543.png";